import { render, staticRenderFns } from "./Bet.vue?vue&type=template&id=d48721fc&scoped=true"
import script from "./Bet.vue?vue&type=script&lang=js"
export * from "./Bet.vue?vue&type=script&lang=js"
import style0 from "./Bet.vue?vue&type=style&index=0&id=d48721fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48721fc",
  null
  
)

export default component.exports